var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 25,
    viewBox: "0 0 38 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4177 4.34409H14.3556V20.6272H23.4177V4.34409Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9309 12.5144C14.9309 9.20598 16.4844 6.27158 18.8722 4.37284C17.1173 2.99195 14.9022 2.15765 12.4856 2.15765C6.76062 2.15765 2.12885 6.78941 2.12885 12.5144C2.12885 18.2394 6.76062 22.8711 12.4856 22.8711C14.9022 22.8711 17.1173 22.0368 18.8722 20.6559C16.4844 18.7572 14.9309 15.794 14.9309 12.5144Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6444 12.5144C35.6444 18.2394 31.0126 22.8711 25.2877 22.8711C22.8711 22.8711 20.6559 22.0368 18.901 20.6559C21.3176 18.7572 22.8423 15.8228 22.8423 12.5144C22.8423 9.20598 21.2888 6.27158 18.901 4.37284C20.6559 2.99195 22.8711 2.15765 25.2877 2.15765C31.0126 2.15765 35.6444 6.78941 35.6444 12.5144Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.8021,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.39121a8be58c36ae38fb24851922a257.svg";
export { ForwardRef as ReactComponent };